import { render } from "./shouyi-news.vue?vue&type=template&id=70c1c1e6&scoped=true"
import script from "./shouyi-news.vue?vue&type=script&lang=js"
export * from "./shouyi-news.vue?vue&type=script&lang=js"

import "./shouyi-news.vue?vue&type=style&index=0&id=70c1c1e6&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c1c1e6"]])

export default __exports__